import React, {Component} from 'react';
import _ from 'lodash';
import { Link } from 'react-router-dom';

import moment from 'moment';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import GarudaEmblem from '../../assets/images/emblem.png';
import UserImage from '../../assets/images/16User.png';
import { speedLevelList, secretLevelList } from '../../utils/documentType';

import SimpleModal from '../../components/SimpleModal';
import SelectDepartmentGroup from '../../components/documents/elements/SelectDepartmentGroup';
import AfterSaveLoading from '../../components/AfterSaveLoading';
import MultipleUpload from '../../components/MultipleUpload';
import RenderFileNames from '../../components/RenderFileNames';
import { ReferenceDocumentForm, RenderRefDocs} from '../../components/documents/elements/ReferenceDocuments';

import DocumentStore from '../../stores/DocumentStore';

const NormalLevel = 'ปกติ';

export default class ExternalReceiveDocumentPage extends Component {
  constructor(props){
    super(props)

    this.state = {
      loading: true,
      open: false,
      due_date: moment(),
      government_service: '',
      issue_number: '',
      topic: '',
      is_circular: false,
      execute: '',
      keywords: '',
      attachment: '',
      document_date: moment(),
      speed_level: NormalLevel,
      secret_level: NormalLevel,
      original_document_file: '',
      files: [],
      references: [],
      informs: [{
        id: '',
        informee_id: '',
        position_name: '',
        executors: [],
        department_group_ids: []
      }],
      document_template: {},
      informees: [],
      department_groups: [],
      reference_documents: []
    }

    this.handleChangeReceiveDate = this.handleChangeReceiveDate.bind(this);
    this.renderSpeedLevel = this.renderSpeedLevel.bind(this);
    this.renderSecretLevel = this.renderSecretLevel.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeDueDate = this.handleChangeDueDate.bind(this);
    this.openSelectInform = this.openSelectInform.bind(this);
    this.onClose = this.onClose.bind(this);
    this.handleChangeInform = this.handleChangeInform.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleChangeOriginalDoc = this.handleChangeOriginalDoc.bind(this);
    this.handleUpdateFiles = this.handleUpdateFiles.bind(this);
    this.onDeleteOriginalFile = this.onDeleteOriginalFile.bind(this);
    this.onDeleteFile = this.onDeleteFile.bind(this);
    this.onChange = this.onChange.bind(this);
    this.handleUpdateReference = this.handleUpdateReference.bind(this);
    this.onDeleteRefDoc = this.onDeleteRefDoc.bind(this);
  }

  componentDidMount(){
    DocumentStore.request({action: 'new_external_receive'}).then((resp)=>{
      let document_template = _.get(resp.data, 'included.document_template', []);
      let informees = _.get(resp.data, 'included.informees', []);
      let department_groups = _.get(resp.data, 'included.department_groups', []);
      let reference_documents = _.get(resp.data, 'included.reference_documents', []);

      this.setState({
        document_template: document_template,
        informees: informees,
        department_groups: department_groups,
        reference_documents: reference_documents
      })
    }).then(()=>{
      this.setState({loading: false});
    })
  }

  handleSave(){
    var data = new FormData();
    var document_attributes = _.get(this.state.document_template, 'attributes.template_attributes', {});

    document_attributes.topic.value = this.state.topic;
    document_attributes.issue_number.value = this.state.issue_number;
    document_attributes.government_service = {};
    document_attributes.government_service.value = this.state.government_service;

    let attachment_obj = {
      attachment: {
        title: 'สิ่งที่ส่งมาด้วย',
        name: 'attachment',
        can_inline_edit: false,
        suggest_text: '',
        value: this.state.attachment
      }
    }
    _.assign(document_attributes, attachment_obj);
    delete(document_attributes.content);
    
    if (!_.isEmpty(document_attributes)){
      _.forEach(document_attributes, function(document_attr, key){
        data.append(`document_attributes[${key}][title]`, document_attr['title']);
        data.append(`document_attributes[${key}][name]`, document_attr['name']);
        data.append(`document_attributes[${key}][can_inline_edit]`, document_attr['can_inline_edit']);
        data.append(`document_attributes[${key}][suggest_text]`, document_attr['suggest_text']);
        data.append(`document_attributes[${key}][value]`, document_attr['value']);
      })
    }

    data.append('document[due_date]', this.state.due_date || '');
    data.append('document[is_circular]', this.state.is_circular || '');
    data.append('document[execute]', this.state.execute || '');
    data.append('document[keywords]', this.state.keywords || '');
    data.append('document[document_date]', this.state.document_date || '');
    data.append('document[speed_level]', this.state.speed_level || '');
    data.append('document[secret_level]', this.state.secret_level || '');
    data.append('document[is_external_receive]', true);
    data.append('document[is_internal_receive]', false);
    data.append('document[document_template_id]', this.state.document_template.id);
    data.append('document[issue_number]', this.state.issue_number || '');

    data.append('original_document_file', this.state.original_document_file || '');

    if (!_.isEmpty(this.state.files)){
      _.forEach(this.state.files, function(file){
        if (!_.isEmpty(file.file_name)){
          data.append('attachments[][id]', file['id'] || '');
          data.append('attachments[][file]', file.file);
        }
      })
    }

    if (!_.isEmpty(this.state.informs)){
      _.forEach(this.state.informs, function(inform){
        data.append('informs[][inform_text]', inform['position_name'] || '');
        
        _.forEach(inform.department_group_ids, function(department_group_id){
          data.append('informs[][department_group_ids][]', department_group_id);
        });
      })
    }

    if (!_.isEmpty(this.state.references)){
      _.forEach(this.state.references, function(ref){
        data.append('references[][id]', ref['id'] || '');
        data.append('references[][reference_text]', ref['reference_text'] || '');
        data.append('references[][document_id]', ref['document_id'] || '');
      })
    }

    DocumentStore.request({
      method: 'post',
      action: 'create_external_receive',
      data: data
    }).then(()=>{
      window.location.href = "/documents/mydoc";
    }, function(error){
      var error_message = _.get(error.response.data, 'error.message', '');
      alert(error_message)
    });
  }

  handleChangeReceiveDate(date){
    this.setState({document_date: date});
  }

  handleChangeDueDate(date){
    this.setState({due_date: date});
  }

  handleChangeSpeedLevel(speed_level){
    this.setState({speed_level: speed_level});
  }

  handleChangeSecretLevel(secret_level){
    this.setState({secret_level: secret_level});
  }

  handleChange(event){
    const field_name = event.target.name;
    var value = event.target.value;

    if (_.includes(['is_circular'], field_name)){
      value = event.target.checked;
    }

    this.setState({
      [field_name]: value
    })
  }

  handleChangeOriginalDoc(event){
    var original_file = event.target.files[0];
    if (original_file === undefined || original_file.size === 0) { return }

    this.setState({
      original_document_file: original_file
    });

    event.target.value = null;
  }

  openSelectInform(){
    this.setState({open: true});
  }

  onClose(){
    this.setState({open: false});
  }

  onChange(){
    const value = this.refs.position_name.value;

    let { informs } = this.state;
    informs[0].position_name = value;
    
    this.setState({informs: informs});
  }

  renderSpeedLevel(speed_level, index){
    return (
      <label 
        key={index} 
        className={`btn btn-secondary ${this.state.speed_level === speed_level && 'active'}`}
        onClick={this.handleChangeSpeedLevel.bind(this, speed_level)}>
        <input type="radio" name="speed_level" id={`speed_level_${index}`} autoComplete="off" checked /> 
        {speed_level}
      </label>
    )
  }

  renderSecretLevel(secret_level, index){
    return (
      <label 
        key={index} 
        className={`btn btn-secondary ${this.state.secret_level === secret_level && 'active'}`}
        onClick={this.handleChangeSecretLevel.bind(this, secret_level)}>
        <input type="radio" name="secret_level" id={`secret_level_${index}`} autoComplete="off" checked /> 
        {secret_level}
      </label>
    )
  }

  handleChangeInform(department_group){
    var { informs } = this.state;
    informs[0].position_name = department_group.informee_name;
    informs[0].executors = department_group.member_names;
    informs[0].department_group_ids = [department_group.id];

    this.setState({
      informs: informs,
      open: false
    });
  }

  handleUpdateFiles(new_files){
    if (_.isEmpty(new_files)) { return }

    var { files } = this.state;
    _.map(new_files, function(file, index){
      if (!_.isEmpty(file.file.name)){
        files = _.concat(files, file);
      }
    })
    
    this.setState({
      files: files
    });
  }

  onDeleteOriginalFile(index){
    if (!window.confirm('ยืนยันการลบไฟล์เอกสารหลัก')) { return }
      
    this.setState({
      original_document_file: ''
    });
  }

  onDeleteFile(index){
      if (!window.confirm('ยืนยันการลบไฟล์')) { return }
        
      var { files } = this.state;
      files.splice(index, 1);

      this.setState({
        files: files
      });
  }

  handleUpdateReference(field_name, value){
      console.log('field_name --->', field_name)
      console.log('value --->', value)

      this.setState({
        [field_name]: value
      });
  }

  onDeleteRefDoc(index){
      if (!window.confirm('ยืนยันการลบ')) { return }

      var { references } = this.state;
      references.splice(index, 1);

      this.setState({
        references: references
      });
  }

  render(){
    const inform = _.first(this.state.informs);
    return (
      <div>
        {this.state.loading && <AfterSaveLoading />}

        <div className='row mb-2'>
          <div className='col-12'>
            <h4 className='my-1'>รับเอกสาร</h4>
          </div>
        </div>

        <div className='row mb-2'>
          <div className='col-6'>
            <strong>ภายนอก</strong>
          </div>
          <div className='col-6 text-right'>
            <button type='button' className='btn btn-success mr-1 pointer' onClick={this.handleSave}>บันทึกรับ</button>
            <Link to='/documents/receive_all' className='btn btn-secondary'>ยกเลิก</Link>
          </div>
        </div>

        <div className='row mb-2'>
          <div className='col-12 text-center'>
            <h3>รับหนังสือภายนอก</h3>
          </div>
          <div className='col-12 text-center'>
            <img alt='Emblem' src={GarudaEmblem} style={{maxWidth: '70pt'}}/>
          </div>
        </div>

        <div className='row mb-2'>
          <div className='col-12 col-md-2'><b>จากหน่วยงาน</b></div>
          <div className='col-12 col-md-10'>
            <input 
              type='text' 
              name='government_service'
              value={this.state.government_service}
              onChange={this.handleChange} 
              className='form-control form-control-sm' />
          </div>
        </div>

        <div className='row mb-2'>
          <div className='col-12 col-md-2'><b>ที่</b></div>
          <div className='col-12 col-md-4'>
            <input 
              type='text' 
              className='form-control form-control-sm'
              name='issue_number'
              value={this.state.issue_number}
              onChange={this.handleChange} />
          </div>
        </div>

        <div className='row mb-2'>
          <div className='col-12 col-md-2'><b>เอกสารลงวันที่</b></div>
          <div className='col-12 col-md-10'>
            <DatePicker
              dateFormat="DD/MM/YYYY"
              selected={this.state.document_date}
              onChange={this.handleChangeReceiveDate}
              className='form-control form-control-sm' />
          </div>
        </div>

        <div className='row mb-2'>
          <div className='col-12 col-md-2'><b>เรื่อง</b></div>
          <div className='col-12 col-md-10'>
            <input 
              type='text' 
              name='topic'
              value={this.state.topic}
              onChange={this.handleChange} 
              className='form-control form-control-sm' />
          </div>
        </div>

        <div className='row mb-2'>
          <div className='col-12 col-md-2'><b>เรียน</b></div>
          <div className='col-12 col-md-10'>

            <div className='card p-3 bg-light'>
              <div className='row'>
                <div className='col-2'>ผู้ดำเนินการ</div>
                <div className='col-1 text-right'>
                  <img alt='ORG' src={UserImage} className='pointer mb-2' onClick={this.openSelectInform} />
                </div>
                <div className='col-9'>
                  {!_.isEmpty(inform.executors) && (
                    <div className='card p-2'>
                      {!_.isEmpty(inform.department_group_ids) && _.map(inform.department_group_ids, (dg_id, index)=>{
                        var dg_object = _.find(this.state.department_groups, {id: dg_id}) || {};
                        
                        return (
                          <div key={index}><strong>{dg_object.attributes.name || ''}</strong></div>
                        )
                      })}
                      <div className='green-border xs-small text-success card p-1'>
                        {inform.executors}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>

          </div>
        </div>

        <div className='row mb-2'>
          <div className='col-12 col-md-12'><h4><b>ประเภทเอกสาร</b></h4></div>
        </div>

        <div className='row mb-2'>
          <div className='col-12 col-md-2'><b>ชั้นความเร็ว</b></div>
          <div className='col-12 col-md-10'>

            <div className="btn-group btn-group-toggle" data-toggle="buttons">
              {_.map(speedLevelList, this.renderSpeedLevel)}
            </div>

          </div>
        </div>

        {this.state.speed_level !== NormalLevel && (
          <div className='row mb-2'>
            <div className='col-12 col-md-2'><b>วันที่คาดว่าจะแล้วเสร็จ</b></div>
            <div className='col-12 col-md-10'>

              <DatePicker
                dateFormat="DD/MM/YYYY"
                selected={this.state.due_date}
                onChange={this.handleChangeDueDate}
                className='form-control' />

            </div>
          </div>
        )}

        <div className='row mb-2'>
          <div className='col-12 col-md-2'><b>ชั้นความลับ</b></div>
          <div className='col-12 col-md-10'>

            <div className="btn-group btn-group-toggle" data-toggle="buttons">
              {_.map(secretLevelList, this.renderSecretLevel)}
            </div>

          </div>
        </div>

        <div className='row mb-2'>
          <div className='col-12 col-md-2'><b>หนังสือเวียน</b></div>
          <div className='col-12 col-md-10'>
            <input 
              type='checkbox' 
              name='is_circular'
              checked={this.state.is_circular}
              onChange={this.handleChange} />
          </div>
        </div>

        <hr className='my-3' />

        <div className='row mb-2'>
          <div className='col-12 col-md-12'><b>เอกสารต้นฉบับ</b></div>
        </div>

        <div className='row mb-2'>
          <div className='col-12 col-md-12'>
            <label className="btn btn-sm btn-success pointer mb-0 mr-2">
              <i className="fa fa-upload mr-1" aria-hidden="true"></i>
                แนบไฟล์-เอกสารต้นฉบับ
                <input 
                  type="file" 
                  name='original_file'
                  hidden
                  onChange={this.handleChangeOriginalDoc} />
            </label>
            <label className='text-danger'>( จำกัดขนาดไฟล์ไม่เกิน 15 MB. , จำกัดประเภทเฉพาะไฟล์นามสกุล .pdf )</label>
          </div>
          {(this.state.original_document_file !== undefined && this.state.original_document_file !== '') && (
            <div className='col-md-12 text-overflow' style={{position: 'relative'}}>
              <i onClick={() => this.onDeleteOriginalFile()}
                  className="fa fa-times top-right pointer" 
                  aria-hidden="true">
                </i>
              {this.state.original_document_file.name}
            </div>
          )}
        </div>

        <hr className='my-3' />

        <div className='row mb-2'>
          <div className='col-12 col-md-2'><b>สิ่งที่ส่งมาด้วย</b></div>
          <div className='col-12 col-md-10'>
            <textarea 
              name='attachment' 
              value={this.state.attachment}
              onChange={this.handleChange}
              className='form-control' />
          </div>
        </div>

        <div className='row mb-2'>
          <div className='col-12 col-md-12'>
            <MultipleUpload 
              label={"แนบไฟล์-เอกสารที่ส่งมาด้วย"}
              limitation_label={"( จำกัดขนาดไฟล์ไม่เกิน 15 MB. )"}
              notice_label={"จำกัดขนาดไฟล์ไม่เกิน 15 MB."}
              onChange={this.handleUpdateFiles} />
              
            <RenderFileNames 
              files={this.state.files}
              onDeleteFile={this.onDeleteFile} />
          </div>
        </div>

        <hr className='my-3' />
        <ReferenceDocumentForm 
          hidden_section={false}
          hidden_ref={false}
          reference_documents={this.state.reference_documents}
          references={this.state.references}
          onChange={this.handleUpdateReference} />
        
        <RenderRefDocs 
          hidden_ref={false}
          references={this.state.references}
          reference_documents={this.state.reference_documents}
          onDeleteRefDoc={this.onDeleteRefDoc} />

        <hr className='my-3' />
        <div className='row mb-2'>
          <div className='col-12 col-md-2'><b>การปฏิบัติ</b></div>
          <div className='col-12 col-md-10'>
            <textarea 
              name='execute' 
              value={this.state.execute}
              onChange={this.handleChange}
              className='form-control' />
          </div>
        </div>

        <hr className='my-3' />

        <div className='row mb-2'>
          <div className='col-12 col-md-2'><b>คำค้น</b></div>
          <div className='col-12 col-md-10'>
            <textarea 
              name='keywords'
              value={this.state.keywords}
              onChange={this.handleChange}
              className='form-control' />
          </div>
        </div>

        <SimpleModal 
          isOpen={this.state.open}
          title={'เรียน'}
          size={'modal-lg'}
          showSubmitButton={false}
          onClose={this.onClose}>
            <SelectDepartmentGroup
              editing_inform={this.state.inform}
              department_groups={this.state.department_groups}
              onChange={this.handleChangeInform}
              onClose={this.onClose} />
        </SimpleModal>

      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/pages/documents/ExternalReceiveDocumentPage.js